import {
  doGETRequest,
  doPOSTRequest,
  doPUTRequest
} from "./Api";

class AccountingApi {

  public static async listAccountingSummary(buyerId: Number) {
    const relativePath = "/accounting/summary?buyerId="+buyerId;
    var response = await doGETRequest(relativePath);
    return response;
  }

  public static async listAccountingTransactions(buyerId: Number) {
    const relativePath = "/accounting/transactions?buyerId="+buyerId;
    var response = await doGETRequest(relativePath);
    return response;
  }

  public static async payForOrder(orderId: Number, form: any) {
    const relativePath = "/accounting/pay-order";
    const body = {orderId: orderId, payType: form.payType, reason: form.reason, amount: form.amount};
    var response = await doPOSTRequest(relativePath, body);
    return response;
  }
}

export default AccountingApi;
